import * as THREE from 'three';
import { LogoMarkStrokes } from './LogoMarkStrokes';
import { LogoMarkMesh } from './LogoMarkMesh';
import { LogoMarkControl } from './LogoMarkControl';
import { DataManager } from '../../data/DataManager';
import { Params } from '../../data/Params';


export class LogoMark extends THREE.Object3D{

    strokes     :LogoMarkStrokes;
    markMesh    :LogoMarkMesh;
    control     :LogoMarkControl;

    constructor(){
        super();
    }

    public init(mesh:THREE.Mesh){

        mesh.material=new THREE.MeshBasicMaterial({color:0xf0f0f0,side:THREE.DoubleSide});

        this.markMesh = new LogoMarkMesh();
        this.markMesh.init();
        this.markMesh.position.z = Params.Z_MARK_MESH;
//        this.markMesh.scale
        this.add(this.markMesh);

        this.strokes = new LogoMarkStrokes();
        this.strokes.init();
        this.strokes.position.z = Params.Z_MARK_STROKES;
        DataManager.getInstance().scene.add(this.strokes);

        this.control = new LogoMarkControl();
        this.control.init(this);

    }

    public boost(){
        this.markMesh.boost();
    }


    //
    public showDotLogo(callback:()=>void=null){
        this.control.Show(callback);
    }

    public hideLogo(callback:()=>void){
        this.control.Hide(callback);
    }



    //mark部分
    public showFillLogo(){
        this.markMesh.showBg();
    }

    public hideFillLogo(){
        this.markMesh.hideBg();
    }

    public update(){
        
        this.strokes?.reset();
        this.markMesh?.update();
        this.control?.update();
        this.strokes?.update();
       
    }

    public resize(){

        //DataManager.getInstance().isWideScreen
        let scl = 1;

        if(window.innerWidth>window.innerHeight){
            scl = window.innerWidth/1280;
            this.scale.set(scl,scl,scl);
        }else{
            scl = window.innerWidth/1280;
            this.scale.set(scl,scl,scl);
        }

    }

}